<template lang="pug">
.c-monaco-editor(v-resize-observer="onResize")
</template>
<script>
export default {
	name: 'MonacoEditor',
	props: {
		value: String,
		language: String,
		lineNumbers: {
			type: Boolean,
			default: false
		},
		modelUri: String,
	},
	data () {
		return {
		}
	},
	computed: {},
	watch: {
		value (newValue) {
			if (this.editor) {
				if (newValue !== this.editor.getValue()) {
					this.editor.setValue(newValue)
				}
			}
		},
	},
	created () {},
	mounted () {
		import(/* webpackChunkName: "designer" */ 'monaco-editor/esm/vs/editor/editor.api').then((monaco) => {
			this.model = monaco.editor.createModel(this.value, this.language, this.modelUri ? monaco.Uri.parse(this.modelUri) : undefined)
			this.editor = monaco.editor.create(this.$el, {
				model: this.model,
				folding: false,
				hideCursorInOverviewRuler: true,
				lineDecorationsWidth: this.lineNumbers ? 10 : 0,
				lineNumbers: this.lineNumbers ? 'on' : 'off',
				minimap: {enabled: false},
				renderLineHighlight: 'none',
				overviewRulerBorder: false,
				overviewRulerLanes: 0,
				wordWrap: 'on'
			})
			this.editor.onDidChangeModelContent(this.onChange)
			this.editor.onDidFocusEditorWidget(this.onFocus)
			this.editor.onDidBlurEditorWidget(this.onBlur)
		})
	},
	beforeDestroy () {
		this.model.dispose()
		this.editor.dispose()
	},
	methods: {
		onResize () {
			if (!this.editor) return
			this.editor.layout()
		},
		onChange () {
			const value = this.editor.getValue()
			if (this.value !== value) {
				this.$emit('input', value)
			}
		},
		onFocus () {
			this.$emit('focus')
		},
		onBlur () {
			this.$emit('blur')
		}
	}
}
</script>
<style lang="stylus">
.c-monaco-editor
	display: flex
	.monaco-editor .suggest-widget
		z-index: 100
		width: 360px

		&.docs-side
			width: 720px
			> .details, > .tree
				float: right
</style>
